"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * A record's details as a two-column definition list.
 *
 * Labels in the product's own face and values in monospace: the labels are
 * read once to find the row you want, and the values are identifiers, times
 * and process numbers that are compared and copied.
 */
const styles = exports.styles = {
  detailGrid: {
    display: "xrvj5dj",
    gridTemplateColumns: "xrwz996",
    columnGap: "xgvynzx",
    rowGap: "xgxkyvb",
    marginBottom: "x1t84w78",
    $$css: true
  },
  detailLabel: {
    fontSize: "x9bimuu",
    color: "xcdm7ny",
    $$css: true
  },
  detailValue: {
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    color: "x10kmngs",
    wordBreak: "x13faqbe",
    $$css: true
  }
};